<template>
  <div style="overflow-x: auto" ref="switchBar">
    <div class="switch-bar">
      <div class="tab" v-for="(tab, index) in data" :key="index" @click="changeTab(index, tab)" :class="{ active: tabIndex === index }" ref="tabs">
        <span>{{ tab.name ? tab.name : tab }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array
    },
    tabIndex: {
      type: Number
    }
  },
  mounted() {
    const scrollPosition = JSON.parse(localStorage.getItem('scrollPosition'))
    if (scrollPosition) {
      this.$refs.switchBar.scrollLeft = scrollPosition.scrollLeft
    }

    if (this.data && this.data.length > 0) {
      this.$emit(
        'changeTabs',
        Number(sessionStorage.getItem('tabIndex')) ? Number(sessionStorage.getItem('tabIndex')) : 0,
        this.data[Number(sessionStorage.getItem('tabIndex')) ? Number(sessionStorage.getItem('tabIndex')) : 0]
      )
    }

    // 给每个 <span> 元素添加点击事件监听器
    const tabs = this.$refs.tabs
    tabs.forEach((span, index) => {
      span.addEventListener('click', () => {
        const scrollLeft = this.$refs.switchBar.scrollLeft
        const spanLeft = span.offsetLeft
        this.saveScrollPosition(scrollLeft, spanLeft)
      })
    })
  },
  methods: {
    changeTab(index, tab) {
      this.$emit('changeTab', index, tab)
    },
    saveScrollPosition(scrollLeft, spanLeft) {
      // 存储滚动位置到本地存储
      localStorage.setItem('scrollPosition', JSON.stringify({ scrollLeft, spanLeft }))
      
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base';
.switch-bar {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  line-height: 4em;
  background-color: #fff;
  .tab {
    // width: 20%;
    text-align: center;
    font-size: 0.37rem;
    color: @title-color-h1;
    position: relative;
    transition: 0.2s all linear;
    //flex-shrink: 0;
    padding: 0 0.2rem;
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 50%;
      width: 0;
      height: 100%;
      border-bottom: 2px solid #000;
      transition: 0.2s all linear;
      border-bottom: 1px solid @main_color;
      transform: translate(0, -0.6em);
    }
    &.active::after {
      width: 64%;
      left: 18%;
      top: 0;
    }
    &.active > span {
      color: @main_color;
    }
    span {
      padding: 0 0.5em 0.4em;
      white-space: pre;
    }
  }
  .active ~ .tab::after {
    left: 50%;
  }
  .tab::before {
    content: '';
    position: absolute;
    width: 1px;
    right: 0;
    top: 20%;
    height: 60%;
    background: @bd_color;
  }
  .tab:last-of-type::before {
    display: none;
  }
}
</style>
